import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { hasPurchaseAccount, isPurchasePath } from "../../Services/PurchaseAccess";
import FeedbackModal from "./FeedbackModal";

export default function PurchaseAccessNotice() {
	const history = useHistory();
	const [visible, setVisible] = useState(false);
	useEffect(() => {
		const show = () => setVisible(true);
		window.addEventListener("purchase-access-required", show);
		return () => window.removeEventListener("purchase-access-required", show);
	}, []);
	useEffect(() => history.block((location) => {
		if (isPurchasePath(location.pathname) && !hasPurchaseAccount()) {
			setVisible(true);
			return false;
		}
		return undefined;
	}), [history]);
	return visible ? <FeedbackModal result="Account Richiesto" label="Accedi con un account prima di poter effettuare degli acquisti." close={() => setVisible(false)} /> : null;
}
